import { render } from "./customer.vue?vue&type=template&id=56d96cd8&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=56d96cd8&scoped=true&lang=css"
import "./customer.vue?vue&type=style&index=1&id=56d96cd8&lang=css"
script.render = render
script.__scopeId = "data-v-56d96cd8"

export default script